import { render, staticRenderFns } from "./BldrField.vue?vue&type=template&id=6456a834"
import script from "./BldrField.vue?vue&type=script&lang=js"
export * from "./BldrField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports